import * as React from "react";
import Helmet from "react-helmet";

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';


// import "../styles";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import Box from "@mui/material/Box";
import {useEffect} from "react";


const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#000',
    },
    secondary: {
      main: "#04D94F",
    },
  },
});

const TemplateWrapper = (props) => {
  const { location } = props;
  const theme = useTheme();

  useEffect(() => {
    try {
      document.oncontextmenu = function(){ return false; };
      // 禁止文字选择
      document.onselectstart = function(){ return false; };
      // 禁止复制
      document.oncopy = function(){ return false; };
      // 禁止剪切
      document.oncut = function(){ return false; };
      // 禁止粘贴
      document.onpaste = function(){ return false; };
    } catch (e) {
    }

  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
        <link rel="shortcut icon" href={require('../images/favicon.ico').default} />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-touch-fullscreen" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black" />
        <meta name="full-screen" content="yes" />

        <link rel="icon" type="image/x-icon" sizes="16x16" href={require('../images/favicon-16x16.png').default} />
        <link rel="icon" type="image/x-icon" sizes="32x32" href={require('../images/favicon-32x32.png').default} />

        <link rel="icon" sizes="192x192" href={require('../images/android-chrome-192x192.png').default} />
        <link rel="icon" sizes="512x512" href={require('../images/android-chrome-512x512.png').default} />

        <link rel="apple-touch-icon-precomposed" sizes="180x180" href={require('../images/android-chrome-180.png').default} />

        <meta name="msapplication-TileColor" content="#000000" />
        <meta name="msapplication-TileImage" content={require('../images/android-chrome-144.png').default} />
      </Helmet>
      <ThemeProvider theme={darkTheme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Header location={location} />
        <Box sx={{
          minHeight: {
            xs: 'calc(100vh - 70px - 435px)',
            sm: 'calc(100vh - 88px - 760px)',
          }
        }}>
          {props.children}
        </Box>
        <Footer location={location} />
      </ThemeProvider>

    </React.Fragment>
  )
};

export default TemplateWrapper;
